/**
 * Packing Exception Types
 *
 * These values match the backend PackingExceptionType enum.
 * Used for filtering and displaying packing exceptions in the orders grid.
 */
export enum PackingExceptionType {
  WrongItem = 'WrongItem',
  MissingItem = 'MissingItem',
  DamagedInventory = 'DamagedInventory',
  PackagingIssue = 'PackagingIssue',
  Other = 'Other',
}
